var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hp-section hp-most_read"},[(_vm.mostReadArticles.length > 0)?_c('homepage-carousel',{attrs:{"category":"mostRead","news-link":_vm.newsLink,"news-items":_vm.mostReadArticles,"news-ads":[],"label":"MOST READ"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }